import { isArray } from 'util';
import { ManufacturingOrderFile } from '../manufacturing-order-file';
import { parseNumber } from '../../utils/number.utils';

export class ManufacturingOrderFileBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderFile(
        json.hash,
        json.fileName,
        json.filePath,
        json.fileCategoryName,
        parseNumber(json.lastUpdate),
        json.assembly3D,
        json.assemblyDrawing
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderFileBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-file.builder.ts